<div [class.ds-hide-filled]="hideWhenFilled"
     [class.ds-hide-focused]="hideWhenFocused"
     class="ds-input__placeholder crop-text"
     *ngIf="placeholder">
  {{placeholder}}
  <span *ngIf="placeholderRemark" class="ds-fine-print ds-color--grey-2">{{placeholderRemark}}</span>
</div>
